export enum GenderEnum {
  Male = 'مرد',
  Female = 'زن',
  UnKnown = 'نامشخص',
}
